import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import {
  convertToObj,
  createRippleEffectRelative,
  removeDefaultParams,
} from '../../../Utils/helper';
import CountDown from './CountDown';
import {
  CountDownBox,
  FlexSection,
  ShopNowCTA,
  TimerContainer,
  TimerHeading,
} from './styled';
import {
  fireClickedCardEvent,
  fireServedSectionInMyloshop,
} from '../../TuesdaySale/saleInstrumentation';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';

export default function TimerWithCTA(props) {
  const { data } = props;
  const router = useRouter();
  const colors = data?.gradientList?.join(',');
  const showNowRef = useRef();
  const value = data?.deeplinkValue;
  const url = value?.split('?')[0];
  const queryInDeepLink = value?.split('?')[1] || '';
  let obj = {};
  if (queryInDeepLink) obj = convertToObj(queryInDeepLink);

  const clikHandler = (event) => {
    fireClickedCardEvent(data);
    event.preventDefault();
    let params = '';
    if (window.location.search) {
      params = window.location.search + '&' + queryInDeepLink;
    } else {
      params = '?' + queryInDeepLink;
    }
    setTimeout(() => {
      router.push(url + params, '', {
        locale: getRouterLocale(router),
      });
    }, 200);
  };

  useEffect(() => {
    fireServedSectionInMyloshop(data);
  }, []);

  return (
    <TimerContainer bgColor={colors}>
      <Link
        href={{
          pathname: url,
          query: removeDefaultParams({ ...router.query, ...obj }),
        }}
        passHref
        locale={false}
        legacyBehavior
      >
        <FlexSection showCta>
          <CountDownBox showCta>
            <TimerHeading>{data?.heading}</TimerHeading>
            <CountDown data={data} />
          </CountDownBox>

          <ShopNowCTA
            as="a"
            ref={showNowRef}
            onClick={(event) => {
              createRippleEffectRelative(event, showNowRef.current);
              clikHandler(event);
            }}
          >
            {data?.ctaText}
          </ShopNowCTA>
        </FlexSection>
      </Link>
    </TimerContainer>
  );
}
